import dayjs from "dayjs";

// K2D "Riportok -> Mérleg / Eredménykimutatás / Főkönyvi riport"
// (w_popup_report_bokrep M/E/P mód) modelljei.

export interface ReportHeadOption {
  id: number;
  name: string;
  year: number;
}

export interface ReportTreeNode {
  id: number;
  level: string; // "maingroup" | "group" | "row"
  code: string;
  name: string;
  children: ReportTreeNode[];
}

// Egy dimenziótípus kijelölt kódjai ('P' mód, K2D dw_dimcode1..9 → imboktemprep_d).
export interface ReportDimensionFilter {
  type: number; // mmbokdimcode.type, 2..10 = I..IX. dimenzió
  dimCodes: string[];
}

export interface RunReportParams {
  mode: string; // 'M' | 'E' | 'P'
  reportHeadId: number;
  fromDate: string;
  toDate: string;
  isStorno: boolean;
  fullPrevYear: boolean;
  inThousands: boolean;
  filler: boolean;
  startRowNo: number;
  periodBal: boolean;
  exactValues: boolean;
  selectedRowIds: number[];
  dimensionFilters: ReportDimensionFilter[];
}

// K2D d_f_hmboktemprep kezdőértékek (pfc_postinsertrow + oszlop-initial-ok):
// időszak = tárgyhó, ezer='+', filler='-', sorszam=1, periodbal='-', konkret='-',
// is_storno='-', full_prev_year='+'.
export const DefaultRunReportParams: RunReportParams = {
  mode: "M",
  reportHeadId: 0,
  fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  isStorno: false,
  fullPrevYear: true,
  inThousands: true,
  filler: false,
  startRowNo: 1,
  periodBal: false,
  exactValues: false,
  selectedRowIds: [],
  dimensionFilters: [],
};

export interface RunReportResult {
  success: boolean;
  message: string;
  runId: number;
  accnoEnabled: boolean;
}

export interface ReportResultRow {
  currentYearId: number;
  previousYearId: number | null;
  previousYearModId: number | null;
  code: string;
  name: string;
  previousYear: number | null;
  previousYearMod: number | null;
  currentYear: number;
  orderNo: number;
  isBold: boolean;
  isItalic: boolean;
  isCode: boolean;
  ejectAfter: boolean;
  row: number;
  rowSign: string;
  group: number;
  groupSign: string;
  maingroup: number;
  repgroup: number;
  repmaingroup: number;
  reprow: number;
  // UI-only: átírt sor (nyomtatás előtt visszaíródik az imboktemprep-be)
  modified?: boolean;
  // UI-only: a fókuszált sor kiemelése – ehhez a sorhoz tartozik a fksz-bontás
  selected?: boolean;
}

export interface ReportAccountRow {
  accno: string;
  name: string;
  previousYear: number | null;
  previousYearMod: number | null;
  currentYear: number | null;
}

export interface ReportAccountDetailRequest {
  runId: number;
  row: number;
  mode: string;
  value1: number;
  value3: number;
  lang: number;
}

export interface ReportRunRowUpdate {
  previousYearId: number | null;
  previousYearModId: number | null;
  currentYearId: number;
  previousYear: number;
  previousYearMod: number;
  currentYear: number;
  orderNo: number;
  ejectAfter: boolean;
}

export interface ReportRunExportRequest {
  runId: number;
  mode: string;
  inThousands: boolean;
  filler: boolean;
  issueDate: string;
  zeroItemVisible: boolean;
  lang: number;
}

// Fksz. ellenőrzés (K2D w_popup_koltsegmatrix_ell): a riport maszkjaiba nem eső könyvelt tételek.
export interface ReportAccountCheckRequest {
  reportHeadId: number;
  mode: string;
  fromDate: string;
  toDate: string;
}

export interface ReportAccountCheckRow {
  id: number;
  transId: number;
  accDate: string;
  accSign: string;
  total: number;
  accno: string;
  partnerName: string;
  note: string;
}

// K2D lang: 1 = magyar (national), 2 = angol (english), 3 = idegen (foreign1)
export const ReportLangOptions = [
  { id: 1, name: "Magyar" },
  { id: 2, name: "Angol" },
  { id: 3, name: "Idegen" },
];
